const translations = {
    organizationNameFieldLabel: 'ORGANIZATION NAME PLEASE'
};

export default translations;
